import { render } from "./General_Invoices.vue?vue&type=template&id=0f3db688&scoped=true"
import script from "./General_Invoices.vue?vue&type=script&lang=js"
export * from "./General_Invoices.vue?vue&type=script&lang=js"

import "./General_Invoices.vue?vue&type=style&index=0&id=0f3db688&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f3db688"]])

export default __exports__